<script>
export default {
  name: 'suppliers.grid-card',
  props: { supplier: { type: Object, default: () => {} } }
}
</script>
<template>
  <b-card no-body class="shadow-sm border border-light">
    <router-link
      :to="{
        name: 'purchase.suppliers.view',
        params: { id: supplier.id }
      }"
    >
      <b-card-header header-bg-variant="white" class="px-3 pt-3 pointer">
        <div class="d-flex justify-content-between align-items-center">
          <b-card-title>
            {{ supplier.legal_name }}
          </b-card-title>
        </div>
        <p class="mt-2 mb-1 text-muted">N° {{ supplier.number }}</p>
        <p class="my-0 text-muted">
          VAT N° {{ supplier.vat_number || 'AA0000000000' }}
        </p>
      </b-card-header>
    </router-link>
    <b-card-footer footer-bg-variant="transparent" class="border-top p-2">
      <div class="d-flex justify-content-start">
        <div class="flex-fill">
          <router-link
            v-b-tooltip.hover.top
            title="Overview"
            :to="{
              name: 'sales.suppliers.view.overview',
              params: { id: supplier.id }
            }"
            ><i class="bx bx-bar-chart p-2"></i>
          </router-link>
          <router-link
            v-b-tooltip.hover.top
            title="Orders"
            :to="{
              name: 'sales.suppliers.view.addresses',
              params: { id: supplier.id }
            }"
            ><i class="bx bx-basket p-2"></i>
          </router-link>
        </div>
        <div class="flex-fill text-right">
          <router-link
            v-b-tooltip.hover.top
            title="Settings"
            :to="{
              name: 'sales.suppliers.settings',
              params: { id: supplier.id }
            }"
            ><i class="bx bx-cog p-2"></i>
          </router-link>
        </div>
      </div>
    </b-card-footer>
  </b-card>
</template>
